import {cameraDefault, sceneCameraType} from './cameras';
import {effectExitWaiting, effectIntro, sceneEffectType} from './effects';
import {sceneEventType, sceneEventTypes} from '../sceneEvents';
import scubeContext from '../../../core/scubeContext';
import sceneContext, {sceneSequenceType, sceneType} from '../sceneEngine';

const devConsoleLog = (message: string) => {
  if (window.isDevelopment) {
    //console.log(message);
  }
};

export const sequenceHelp: sceneSequenceType | any = {
  onStart(context: sceneContext & sceneHelpContextType) {
    context.walkTimes = 2;
    context.idle = true;
    context.sleep = false;

    context.startCamera(cameraDefault);
    context.startEffect(effectIntro);
    context.fadeToAnimation('Walking');

    //context.setSize(600,200);
  },

  onFinish(context: sceneContext & sceneHelpContextType) {
    //stop events
    //stop animations
  },

  selectIdle(exceptKey: string) {
    const animations = ['Idle', 'Happy', 'Tablet', 'Bashful'];
    const filteredAnimations = animations.filter((key) => key != exceptKey);
    const order = Math.floor(Math.random() * Math.floor(filteredAnimations.length));
    return filteredAnimations[order];
  },

  selectIntermezzo() {
    let animations = [];
    if (scubeContext.tenantType === 'physical') {
      animations = [
        'Secret',
        'Yawn',
        'Thankful',
        'Reacting',
        'Looking',
        'Jump',
        'Climbing',
        'SillyDancing',
        'RumbaDancing',
        'Looking2',
        'Macarena',
        'Salsa',
        'Pointing',
        'LookingBehind',
        'No',
        'Yes',
      ];
    } else {
      animations = ['Secret', 'Thankful', 'Reacting', 'Looking', 'Looking2', 'Pointing', 'LookingBehind', 'No', 'Yes'];
    }
    let order = Math.floor(Math.random() * Math.floor(animations.length));
    return animations[order];
  },

  onAnimationFinished(context: sceneContext & sceneHelpContextType, animationName: string) {
    //devConsoleLog('onAnimationFinished:' + animationName);

    // waiting
    if (context.sleep) {
      // DAVID STOP
      return;
    }

    // intro walking
    if (animationName === 'Walking') {
      if (context.walkTimes > 0) {
        //devConsoleLog('onAnimationFinished: context.walkTimes > 0' + animationName);

        context.walkTimes -= 1;
      } else {
        //devConsoleLog('onAnimationFinished: else context.walkTimes > 0' + animationName);

        // run first idle
        context.fadeToAnimation('Greeting');
        context.idle = false;
      }
    } else {
      if (context.idle && (context.idleTimes == 0 || !context.idleTimes)) {
        //devConsoleLog('onAnimationFinished: context.idle' + animationName);

        let anim = this.selectIntermezzo();
        context.fadeToAnimation(anim);
        if (anim === 'Yes') {
          context.startEffect(effectExitWaiting);
        }
        context.idle = false;
      } else {
        //console.log('onAnimationFinished: else context.idle' + animationName);
        //console.log({ walkTimes: context.walkTimes });

        if (context.idleTimes > 0) {
          context.idleTimes--;
          //context.fadeToAnimation(context.lastIdleAnimation);
          //console.log({ action: 'decreaseidle', idleTimes: context.idleTimes });
        } else {
          context.idle = true;
          context.idleTimes = 3;
          context.lastIdleAnimation = this.selectIdle(context.lastIdleAnimation);
          context.fadeToAnimation(context.lastIdleAnimation);
          //console.log({ action: 'gotoIdle', anim: context.lastIdleAnimation, idleTimes: context.idleTimes });
        }
      }
    }
  },

  onEffectFinished(context: sceneContext & sceneHelpContextType, effect: sceneEffectType) {
    if (effect === effectExitWaiting && !context.sleep) {
      context.startEffect(effectIntro);
    }
  },

  onCameraFinished(context: sceneContext, camera: sceneCameraType) {},

  onEvent(context: sceneContext & sceneHelpContextType, sceneEvent: sceneEventType) {
    // devConsoleLog("chat event received");
    //devConsoleLog(sceneEvent);
    if (
      sceneEvent.eventType === sceneEventTypes.ReceivedChatButtonSet ||
      sceneEvent.eventType === sceneEventTypes.ReceivedQuestionnaireAmyText ||
      sceneEvent.eventType === sceneEventTypes.ReceivedChatQuestion
    ) {
      if (!context.walkTimes) {
        context.idleTimes = 0;

        let animations = ['HandRising', 'Waving', 'Waving2'];
        let order = Math.floor(Math.random() * Math.floor(animations.length));
        context.fadeToAnimation(animations[order]);
      }
    }

    if (sceneEvent.eventType === sceneEventTypes.SentChatAnswer) {
      //context.startEffect(effectExitWaiting);
    }

    if (sceneEvent.eventType === sceneEventTypes.ReceivedAmyEvent) {
      if (sceneEvent.eventSubType === 'end-session') {
        context.sleep = true;
        context.startEffect(effectExitWaiting);
      }
    }
  },
  isRecurrent: true,
};

type sceneHelpContextType = {
  sleep: boolean;
  firstPass: boolean;
  walkTimes: number;
  idle: boolean;

  idleTimes: number;
  lastIdleAnimation: string;
};

export const sceneHelp: sceneType = {
  id: 'sceneHelp',
  name: 'help', //development field only
  modelName: 'amy_psychologist.glb',
  onStart: (context: sceneContext) => {
    context.startSequence(sequenceHelp as any);
  },
  onStop: (context: sceneContext) => {},

  onFinish: (context: sceneContext) => {},
  onSequenceFinished: (sequenceName: string) => {},
  onEffectFinished: (effectName: string) => {},
  onEvent: (context: sceneContext, sceneEvent: sceneEventType) => {},
  sequences: [sequenceHelp],
  amySettings: {
    particlesHitArea: false,
    particlesRandom: 30.0, //1.5
    particlesDepth: 2, //6 //6.06
    particlesXYMove: true, //true
    particlesBW: false,
    particlesSquare: false,
    particlesSize: 0.5, //4.0, //3.2
    particlesSmooth: 0.9, // //0.3
    particlesShift: 0,
    matrix: 128, //128, // 100
    planeRotate: 0,
  },
};
